export default function getFormattedDate(
  zdate,
  returnType = "",
  seperator = "-"
) {
  // seperators { -, /, " "}
  const Ydate = new Date(zdate);
  // Year
  const year = Ydate.getFullYear();
  // Month
  let month = (1 + Ydate.getMonth()).toString();
  month = month.length > 1 ? month : `0${month}`;
  // Month in letters
  const monthName = Ydate.toLocaleString("default", { month: "long" });
  // Day
  let day = Ydate.getDate().toString();
  day = day.length > 1 ? day : `0${day}`;

  let hours = Ydate.getHours();
  let minutes = Ydate.getMinutes();
  let seconds = Ydate.getSeconds();
  const meridiem = hours >= 12 ? "PM" : "AM";
  hours %= 12 || 12;
  minutes = minutes < 10 ? `0${minutes}` : minutes;
  seconds = seconds < 10 ? `0${seconds}` : seconds;

  switch (returnType) {
    case "yyyy-mm-dd":
      return `${year}${seperator}${month}${seperator}${day}`; // 2021-11-23
    case "mm-dd-yyyy":
      return `${month}${seperator}${day}${seperator}${year}`; // 11-23-2021
    case "dd-mm-yyyy":
      return `${day}${seperator}${month}${seperator}${year}`; // 23-11-2021
    case "FullDate":
      return `${monthName} ${day}, ${year}`; // November 23, 2021
    case "shortDate":
      return `${monthName.slice(0, 3)} ${day}, ${year}`; // Nov 23, 2021
    case "Date-Time":
      return `${day}${seperator}${month}${seperator}${year}, ${hours}:${minutes}:${seconds} ${meridiem}`;
    default:
      return `${year}${seperator}${month}${seperator}${day}`;
  }
}
export const compareDateWithCurrentDate = (date, operator = ">") => {
  const today = new Date(new Date().toISOString()).getTime();
  const comparingDate = new Date(new Date(date).toISOString()).getTime();
  switch (operator) {
    case ">":
      return comparingDate > today;
    case ">=":
      return comparingDate >= today;
    case "<":
      return comparingDate < today;
    case "<=":
      return comparingDate <= today;
    default:
      return comparingDate > today;
  }
};
